// Ownezzy Cancellation & Refund Policy for website plans bought on ownezzy.com (stores' own refunds are each Seller's).
// Each section: { heading, text?: [paragraphs], list?: [items] }. Have changes reviewed by a lawyer before publishing.
// C: Ownezzy's contact (useOwnezzyContact in ./contact.js)
export const refundFor = (C) => ({
  title: 'Cancellation & Refund Policy',
  lastUpdated: '3 November 2026',
  intro: [
    `This policy covers payments made to Ownezzy (operated by ${C.operator}, sole proprietor, India) for website plans, renewals, add-ons and domain names bought on ownezzy.com or in the Ownezzy admin panel.`,
    'It does not cover purchases from a store built on Ownezzy. Those payments go directly to the Seller, and each Seller handles their own cancellations and refunds (see our Terms of Service).',
  ],
  sections: [
    {
      heading: '1. Try before you pay',
      text: ['Every new account can start with the free trial (₹0, no card needed) to build and test a store before buying a plan.'],
    },
    {
      heading: '2. Cancelling a plan',
      list: [
        'Plans are prepaid for the chosen period (monthly or yearly) and do not renew automatically. To cancel, simply do not renew: the store stays active until the end of the paid period.',
        'You can also ask us to close your account at any time on WhatsApp or by email. Closing an account before the end of a paid period does not give a refund for the unused part.',
      ],
    },
    {
      heading: '3. Refunds',
      list: [
        'Plan fees, first-month offers, renewals and add-ons are not refundable once the plan is active, except where Indian law requires a refund.',
        'Domain names registered for you are paid to a third-party registrar and cannot be refunded once registered.',
        'If you were charged but your plan or website was not activated, or you were charged twice for the same purchase, write to us within 7 days with the payment reference. After checking, we activate the plan or refund the extra payment in full.',
        'Approved refunds go back to the original payment method (UPI, card or bank) within 5–7 working days. Your bank may take a few more days to show it.',
      ],
    },
    {
      heading: '4. Currency and international payments',
      list: [
        'All plan prices are in Indian Rupees (₹). Visitors outside India also see an approximate US$ amount, for information only.',
        'International cards are charged in rupees and your bank converts the amount into your currency at its own rate, and may add its own fees. A refund is made in rupees for the amount we received, so the amount back in your currency can differ slightly because of exchange rates and bank charges, which we do not control.',
      ],
    },
    {
      heading: '5. Stores paused for breaking the rules',
      text: ['A store paused or removed for breaking our Terms of Service or the law is not entitled to a refund.'],
    },
    {
      heading: '6. Contact',
      text: [`For cancellations, refunds or a payment problem: ${C.email} or WhatsApp ${C.whatsapp} (9 AM to 9 PM, every day). Please include your store address and the payment reference.`],
    },
  ],
});
